var resumeData = {
	"imagebaseurl": "https://princelle.org/en",
	"lang": "en",
	"langs": [
		["/fr", "🇫🇷 Français"],
		["/en", "🇺🇸 English"],
	],
	"changeLang": "Change Language?",
	"welcome": "Welcome !",
	"name": "I am Maxime Princelle.",
	"roleDescription": [
		"Full-Stack Developer",
		"SysAdmin",
		"DevOps Engineer"
		//"Student in Computer Science",
		//"Solution Finder"
	],
	"socialLinks": [
		/*{
			"name": "blog",
			"url": "https://blog.princelle.org",
			"className": "fas fa-blog"
		},*/
		{
			"name": "facebook",
			"url": "https://www.facebook.com/ThePrincelle",
			"className": "fab fa-facebook-f"
		},
		{
			"name": "twitter",
			"url": "https://twitter.com/ThePrincelle",
			"className": "fab fa-twitter"
		},
		/* {
			"name": "snapchat",
			"url": "https://www.snapchat.com/add/princellemaxime",
			"className": "fab fa-snapchat"
		}, */
		{
			"name": "instagram",
			"url": "https://www.instagram.com/theprincelle/",
			"className": "fab fa-instagram"
		},
		{
			"name": "linkedin",
			"url": "https://fr.linkedin.com/in/maxime-princelle-08ba82157",
			"className": "fab fa-linkedin"
		},
		{
			"name": "git",
			"url": "https://github.com/ThePrincelle",
			"className": "fab fa-github"
		},
		{
        	"name": "gitlab",
        	"url": "https://git.unistra.fr/princelle",
        	"className": "fab fa-gitlab"
		}
		/*{
			"name": "spotify",
			"url": "https://open.spotify.com/user/ge9z5kvkf2mh34lkex1a403hj?si=YtacyhRST3qMCmu-7LVJqg",
			"className": "fab fa-spotify"
		}*/
	],
	"aboutme": [
		"I am mainly interested in the field of new technologies, web, AI, Smart Houses.",
		"On my personal time, I developed a complete home automation system and I had the opportunity to perfect myself on different systems.",
		"Although spending most of my time on a computer, I also practice other activities such as piano and singing."
	],
	"moreme": [
		{
			"name": "Objectives",
			"icon": "fas fa-bullseye",
			"text": "My goal, for the moment, is to learn as much as possible during my studies in order to prepare myself as well as possible for the world of work and active life. Each internship, each summer job, is for me a challenge in order to better adapt to the demand and continue to deepen my knowledge."
		},
		{
			"name": "Creativity",
			"icon": "fas fa-pencil-ruler",
			"text": "The world of computing is in itself for me in constant demand for creativity. Despite the fact that language is common, it is important in my opinion, never stop innovating to enable software or system to remain the most innovative, as long as possible."
		},
		{
			"name": "Team work",
			"icon": "fas fa-users",
			"text": "Teamwork is for me, something of paramount importance. For as Steve Jobs had said: \"Great things in business are never done by one person. They're done by a team of people.\" And that's where all the interest of teamwork is concerned."
		},
		{
			"name": "Learn",
			"icon": "fas fa-graduation-cap",
			"text": "In this field, computer science, we must never stop learning, whether new programming methods or simply a new language, the person who learns in this field, must maintain a constant technology watch while continuing to improve by investing to the maximum in a project."
		}
	],
	"eduDesc": [
		"Here you will find the different schools I've done.",
		"One of my goals is to learn, I think it is important to be well trained and prepare yourself before entering the workforce."
	],
	"learnmore": "Learn more...",
	"education": [
		{
			"name": "Junior High - Louis Arbogast",
			"loc": "Mutzig, France",
			"locLink": "https://goo.gl/maps/QFgEU6aUsiZpVL6H9",
			"date": "2010 - 2014",
			"desc": [
				"During these four years, I invested myself in the associative life and contributed to several events (Concert of end of the year, Open Day, etc)."
			],
			"link": "http://www.education.gouv.fr/annuaire/67-bas-rhin/mutzig/college/college-louis-arbogast.html"
		}, {
			"name": "High School - Louis Marchal",
			"loc": "Molsheim, France",
			"locLink": "https://goo.gl/maps/hsTS1XKXLcGLAUTr6",
			"date": "2014 - 2017",
			"desc": [
				"I attended STI2D training (Science and Technology of Industry and Sustainable Development) specialty INS (Information System and Digital).",
				"I participated in the life of the school through the association \"Maison des Lycéens\" but also being a delegate and member of the CVL (Council of Student Life).",
				"I got my bachelor's degree with honors \"Very Good\"."
			],
			"link": "http://www.lycee-marchal.com/"
		}, {
			"name": "University of Strasbourg - Associate's Degree in Computer Science",
			"loc": "Illkirch, France",
			"locLink": "https://goo.gl/maps/CJP6MMdss9kCzqgH7",
			"date": "2017 - 2019",
			"desc": [
				"I learn different programming languages as well as algorithmic and systems operation but also project management while preparing for the world of business."
			],
			"link": "http://iutrs.unistra.fr/"
		}, {
			"name": "University of Strasbourg - Bachelor's degree Co-Op",
			"loc": "Illkirch, France",
			"locLink": "https://goo.gl/maps/CJP6MMdss9kCzqgH7",
			"date": "2019 - 2020",
			"desc": [
				"Bachelor's degree Co-Op : Design and Development of Distributed Applications.",
				"I learn the operation and configuration of servers and more in -depth the development of websites and Android mobile apps."
			],
			"link": "http://iutrs.unistra.fr/"
		}
	],
	"workDesc": [
		"Here you will find the different professional experiences I have acquired."
	],
	"work": [
		{
			"name": "Solu-Tech",
			"loc": "Rosheim, France",
			"locLink": "https://goo.gl/maps/jejsTAkaHi52s8rg9",
			"date": "2018 (2 months)",
			"desc": [
				"My first steps in the world of business. Here I was in charge of doing some missions, based mainly on industrial computing.",
				"I had the opportunity to learn about PowerShell, PHP or SQL ...",
			],
			"link": "https://www.solu-tech.fr/"
		}, {
			"name": "Solu-Tech",
			"loc": "Rosheim, France",
			"locLink": "https://goo.gl/maps/jejsTAkaHi52s8rg9",
			"date": "2019 (4 months)",
			"desc": [
				"On the occasion of my internship during my DUT, I decided to go back to Solu-Tech.",
				"My mission was to improve the intranet site to manage the hours and expenses of employees.",
				"In order to meet this need, I decided to take over the site from scratch to be able to develop an API in NodeJS and a web client in React."
			],
			"link": "https://www.solu-tech.fr/"
		}, {
			"name": "Ubertone",
			"loc": "Schiltigheim, France",
			"locLink": "https://goo.gl/maps/5RPbdKcjJXddsSmQA",
			"date": "2019 - 2020",
			"desc": [
				"On the occasion of my Co-Op, I decided to go for the business start-up type."
			],
			"link": "http://ubertone.com/"
		}
	],
	"skillsDescription": "Here is a list of my skills and different software that I own and use, during my studies or the realization of personal projects.",
	"skills": [
		{
			"name": "English",
			"icon": "/images/skills/english.png",
			"linkText": "Level B2 (CECRL)",
			"link": "https://www.efset.org/fr/english-score/cefr/b2/",
			"type": "",
			"text": [
				"I am learning English during my studies since Grade 4.",
				"I am getting better daily by traveling and watching all the TV shows I follow in English.",
				"I also got the TOEIC in 2019 with 870 points out of 990."
			]
		},
		{
			"name": "Git",
			"icon": "/images/skills/git.png",
			"linkText": "Link to the website",
			"link": "https://git-scm.com/",
			"type": "Version Management Software",
			"text": [
				"It makes it possible to simplify teamwork as much as possible and to avoid dealing with code management."
			]
		},
		{
			"name": "Visual Studio Code",
			"icon": "/images/skills/vscode.png",
			"linkText": "Link to the website",
			"link": "https://code.visualstudio.com/",
			"type": "",
			"text": [
				"This code editor has the advantage of being very customizable.",
				"Also it is compatible with most languages.",
			]
		},
		{
			"name": "Trello",
			"icon": "/images/skills/trello.png",
			"linkText": "Link to the website",
			"link": "https://trello.com/home",
			"type": "Productivity Software",
			"text": [
				"This tools allows a team to create task boards with several columns and move the tasks between them.",
				"Typically columns include task statuses:",
				"To Do, In Progress, Done."
			]
		},
		{
			"name": "Linux",
			"icon": "/images/skills/linux.png",
			"linkText": "Learn more...",
			"link": "https://wikipedia.org/wiki/Linux",
			"type": "Operating system",
			"text": [
				"I use it mainly for managing the home automation environment at my home.",
				"Several servers are responsible for managing devices, others for files and multimedia, etc."
			]
		},
		{
			"name": "Docker",
			"icon": "/images/skills/docker.png",
			"linkText": "Link to the website",
			"link": "https://www.docker.com",
			"type": "Container Platform",
			"text": [
				"I'm placing today all of my applications in Docker containers.",
				"I can manage each of them individually while securing maximum their access."
			]
		},
		{
			"name": "Android Studio",
			"icon": "/images/skills/android_studio.png",
			"linkText": "Link to the website",
			"link": "https://developer.android.com/studio/",
			"type": "",
			"text": [
				"This software allows me to create Android applications and simulate an environment in stride.",
				"It has the advantage of integrating Git and ADB tools."
			]
		},
		{
			"name": "Office Suite",
			"icon": "/images/skills/office.png",
			"linkText": "Link to the website",
			"link": "https://www.office.com/",
			"type": "Word processing, presentation, etc. software",
			"text": [
				"I use the Office suite since the 2003 version.",
				"So I have today, pretty good knowledge on Word, PowerPoint, Excel, Visio, etc."
			]
		},
		{
			"name": "Adobe Photoshop",
			"icon": "/images/skills/photoshop.png",
			"linkText": "Link to the website",
			"link": "https://www.adobe.com/fr/products/photoshop.html",
			"type": "Graphics software",
			"text": [
				"I use this software regularly to edit or create images for different occasions.",
				"Example: website creation, interfaces, icons, etc."
			]
		},
		{
			"name": "Final Cut Pro",
			"icon": "/images/skills/finalcut.png",
			"linkText": "Link to the website",
			"link": "https://www.apple.com/fr/final-cut-pro/",
			"type": "Video editing software",
			"text": [
				"This software is only available on Mac.",
				"I use it as soon as I have a video to edit whether for a project or a homework assignment."
			]
		}
	],
	"langagesDesc": "Here are the platforms and different languages and frameworks that I use.",
	"langages": [{
		"name": "HTML",
		"icon": "/images/langages/html.png",
		"desc": "",
		"link": "https://wikipedia.org/wiki/Hypertext_Markup_Language",
		"linkTitle": "Wikipedia"
	},
	{
		"name": "CSS",
		"icon": "/images/langages/css.png",
		"desc": "",
		"link": "https://wikipedia.org/wiki/Feuilles_de_style_en_cascade",
		"linkTitle": "Wikipedia"
	},
	{
		"name": "JavaScript",
		"icon": "/images/langages/js.png",
		"desc": "",
		"link": "https://wikipedia.org/wiki/JavaScript",
		"linkTitle": "Wikipedia"
	},
	{
		"name": "React",
		"icon": "/images/langages/react.png",
		"desc": "Web Framework",
		"link": "https://wikipedia.org/wiki/React_(JavaScript)",
		"linkTitle": "Wikipedia"
	},
	{
		"name": "Laravel",
		"icon": "/images/langages/laravel.png",
		"desc": "Web Framework",
		"link": "https://wikipedia.org/wiki/Laravel",
		"linkTitle": "Wikipedia"
	},
	{
		"name": "Java",
		"icon": "/images/langages/java.png",
		"desc": "",
		"link": "https://wikipedia.org/wiki/Java_(langage)",
		"linkTitle": "Wikipedia"
	},
	{
		"name": "PHP",
		"icon": "/images/langages/php.png",
		"desc": "",
		"link": "https://wikipedia.org/wiki/PHP",
		"linkTitle": "Wikipedia"
	},
	{
		"name": "Python",
		"icon": "/images/langages/python.png",
		"desc": "",
		"link": "https://wikipedia.org/wiki/Python_(langage)",
		"linkTitle": "Wikipedia"
	},
	{
		"name": "C#",
		"icon": "/images/langages/csharp.png",
		"desc": "",
		"link": "https://wikipedia.org/wiki/C_sharp",
		"linkTitle": "Wikipedia"
	},
	{
		"name": "SQL",
		"icon": "/images/langages/sql.png",
		"desc": "Databases",
		"link": "https://wikipedia.org/wiki/Structured_Query_Language",
		"linkTitle": "Wikipedia"
	},
	{
		"name": "BASH",
		"icon": "/images/langages/bash.png",
		"desc": "Shell Script",
		"link": "https://wikipedia.org/wiki/Bourne-Again_shell",
		"linkTitle": "Wikipedia"
	},
	{
		"name": "SAS",
		"icon": "/images/langages/sas.png",
		"desc": "Statistics",
		"link": "https://wikipedia.org/wiki/SAS_Institute",
		"linkTitle": "Wikipedia"
	},
	{
		"name": "C",
		"icon": "/images/langages/c.png",
		"desc": "",
		"link": "https://wikipedia.org/wiki/C_(langage)",
		"linkTitle": "Wikipedia"
	},
	{
		"name": "Android",
		"icon": "/images/langages/android.png",
		"desc": "Mobile OS",
		"link": "https://wikipedia.org/wiki/Android",
		"linkTitle": "Wikipedia"
	},
	{
		"name": "iOS",
		"icon": "/images/langages/ios.png",
		"desc": "Mobile OS",
		"link": "https://wikipedia.org/wiki/iOS",
		"linkTitle": "Wikipedia"
	},
	{
		"name": "macOS",
		"icon": "/images/langages/mac.png",
		"desc": "Desktop OS",
		"link": "https://wikipedia.org/wiki/Mac_OS",
		"linkTitle": "Wikipedia"
	},
	{
		"name": "Linux",
		"icon": "/images/langages/linux.png",
		"desc": "Desktop OS",
		"link": "https://wikipedia.org/wiki/Linux",
		"linkTitle": "Wikipedia"
	},
	{
		"name": "Windows",
		"icon": "/images/langages/windows.png",
		"desc": "Desktop OS",
		"link": "https://wikipedia.org/wiki/Microsoft_Windows",
		"linkTitle": "Wikipedia"
	}
	],
	"projectTitle": "Here are some of my projects",
	"projects": [{
		"name": "Plantae",
		"date": "2018",
		"desc": "Educational game",
		"link": "https://plantae.princelle.org",
		"linkText": "Link to the project",
		"git": "https://github.com/ThePrinceMax/Plantae",
		"gitText": "Link to Git repo",
		"imgurl": "/images/projects/t3.png",
		"tags": [
			["HTML", ""],
			["CSS", ""],
			["JS", ""],
			["PHP", ""],
			["Ratchet", "http://socketo.me"],
			["Bootstrap", "https://getbootstrap.com"]
		],
		"text": [
			"This project was realized as part of the T3 module during my computer science degree.",
			"The main subject is botany, the goal of the game is to keep his flower alive as long as possible.",
			"This game is played with two players, either against the computer or against an opponent online."
		]
	}, {
		"name": "Accuracy Robots",
		"date": "2019",
		"desc": "Educational game (Prototype)",
		"link": "https://accuracyrobots.princelle.org",
		"linkText": "Link to the project",
		"git": "https://github.com/ThePrinceMax/Accuracy-Robots",
		"gitText": "Link to Git repo",
		"imgurl": "/images/projects/t4.png",
		"tags": [
			["JS", ""],
			["HTML", ""],
			["CSS", ""],
			["React", "https://reactjs.org"],
			["React Bootstrap", "https://react-bootstrap.github.io"]
		],
		"text": [
			"This project was realized as part of the T4 module during my computer science degree.",
			"The game is played in turn. The goal is to keep a robot to a certain level of integrity so that it does not explode.",
			"The principle of this game follows the laws of Asimov."

		]
	}, {
		"name": "Cloud Princelle",
		"date": "2019",
		"desc": "Cloud storage",
		"link": "https://cloud.princelle.org",
		"linkText": "Link to the project",
		"git": "",
		"gitText": "",
		"imgurl": "/images/projects/cloud.png",
		"tags": [
			["HTML", ""],
			["CSS", ""],
			["JS", ""],
			["PHP", ""]
		],
		"text": [
			"After searching for an online storage solution for a long time, I decided to create my own cloud service.",
			"Based on the open source software NextCloud, I modified the latter to open this service to several people to allow the editing of documents in real time."
		]
	}, {
		"name": "Blog Princelle",
		"date": "2019",
		"desc": "Blog",
		"link": "https://blog.princelle.org",
		"linkText": "Link to the project",
		"git": "",
		"gitText": "",
		"imgurl": "/images/projects/blog.png",
		"tags": [
			["HTML", ""],
			["CSS", ""],
			["JS", ""],
			["WordPress", "https://wordpress.org/"]
		],
		"text": [
			"I created it for my Bachelor's degree Co-Op. It allows me to directly write posts wherever I want to.",
			"I'm using WordPress because I didn't have a lot of time to build a website and a mobile app."
		]
	}, {
		"name": "Home",
		"date": "2018",
		"desc": "Home Automation Software",
		"link": "https://home.princelle.org",
		"linkText": "Link to the project",
		"git": "",
		"gitText": "",
		"imgurl": "/images/projects/home.png",
		"tags": [
			["HTML", ""],
			["JS", ""],
			["CSS", ""],
			["PHP", ""],
			["Modernizr", "https://modernizr.com"],
			["Bootstrap", "https://getbootstrap.com"],
			["jQuery", "https://jquery.com/"],
			["AngularJS", "https://angular.io/"]
		],
		"text": [
			"Based on the Jeedom open source software, this system allows me to create an interface between the devices in my home and the different clients (mobiles, tablets, and voice assistants).",
			"This system also allows interactions and automations around the devices, whether for heating, multimedia, or lighting, ...",
			"I have also developed a unique interaction system for all types of clients connected to the system, whether SMS or via voice with Google Assistant."
		]
	}, {
		"name": "Form Princelle",
		"date": "2019",
		"desc": "Online Surveys",
		"link": "https://form.princelle.org",
		"linkText": "Link to the project",
		"git": "",
		"gitText": "",
		"imgurl": "/images/projects/form.png",
		"tags": [
			["PHP", ""],
			["HTML", ""],
			["JS", ""],
			["CSS", ""],
			["Bootstrap", "https://getbootstrap.com"]
		],
		"text": [
			"I have long searched for a service that allows me to do surveys online, but I never found what I wanted.",
			"So I decided to deploy mine, based on LimeSurvey (also open source), I also made changes, especially in the processing of responses but also in the design of interfaces."
		]
	},/* {
		"name": "DB Princelle",
		"date": "2018",
		"desc": "Databases",
		"link": "https://db.princelle.org",
		"linkText": "Link to the project",
		"git": "",
		"gitText": "",
		"imgurl": "/images/projects/db.png",
		"tags": [
			["MySQL", ""],
			["phpMyAdmin", "https://www.phpmyadmin.net/"]
		],
		"text": [
			"In order to host all my applications without problems, I also set up a database.",
			"The latter is only accessible locally on my server, and can be managed using phpMyAdmin."
		]
	},*/ {
		"name": "HomePrince",
		"date": "2019",
		"desc": "Project - Business Creation",
		"link": "https://homeprince.princelle.org",
		"linkText": "Link to the website",
		"git": "https://github.com/ThePrinceMax/HomePrince-Website",
		"gitText": "Link to Git repo",
		"imgurl": "/images/projects/homeprince.png",
		"tags": [
			["HTML", ""],
			["CSS", ""],
			["JS", ""],
			["PHP", ""],
			["Bootstrap", "https://getbootstrap.com"]
		],
		"text": [
			"This is an application developed as part of the E4a module during my computer science degree.",
			"The idea was to create a company of our choice and to develop a business plan."
		]
	}, {
		"name": "My Resume",
		"date": "2019",
		"desc": "Online Resume",
		"link": "https://princelle.org",
		"linkText": "Link to the project",
		"git": "https://github.com/ThePrinceMax/Personal-Website",
		"gitText": "Link to Git repo",
		"imgurl": "/images/projects/portfolio.png",
		"tags": [
			["JS", ""],
			["HTML", ""],
			["CSS", ""],
			["React", "https://reactjs.org"],
			["Modernizr", "https://modernizr.com"]
		],
		"text": [
			"You are on it.",
			"Recently updated, this website presents who I am and the different projects I have done."
		]
	}
	],
	"awardsDesc": [
		"Here you will find the awards that I received in the competitions in which I participated."
	],
	"awards": [{
		"event": "'24h des IUT'",
		"name": "1st place - 'Artificial Intelligence' event",
		"loc": "University Le Havre, France",
		"locLink": "https://goo.gl/maps/2BMVp4VK8sLuySDz9",
		"date": "2019 Edition",
		"desc": [
			"The goal was to build an AI program to solve a given problem.",
			"In order to realize a powerful program, we chose the Python language.",
			"The idea was to create a network connection to a server in order to play against him.",
			"The goal was to realize the most powerful program but also with the best possible strategy while respecting the given rules."
		],
		"linkDescAwards": "Learn more about the event...",
		"link": "https://di.iut.univ-lehavre.fr/24hinfo/index.php"
	}],
	"contactDesc": "Do you want to ask me a question or something?",
	"contactWhere": "Where to find me?",
	"adress": [
		"49, Rue du fossé",
		"67280 Niederhaslach",
		"France"
	],
	"adressGMAPS": "https://goo.gl/maps/bQDsFxJ38kp",
	"phone": "+33 6 29 24 93 52",
	"phoneLink": "tel:+33629249352",
	"mail": "contact-maxime (at) princelle.org",
	"contactOther": "Contact me",
	"formTitle": "Send me a message.",
	"formNameLabel": "Your name",
	"formNamePlaceholder": "Place your name here.",
	"formMailLabel": "Your e-mail",
	"formMailPlaceholder": "Place your e-mail here.",
	"formSujetLabel": "Subject",
	"formSujetPlaceholder": "Insert the subject of your message here.",
	"formMsgLabel": "Message",
	"formMsgPlaceholder": "Insert your message here.",
	"btnSend": "Send",
	"emptyInputs": "Please fill in all the blanks.",
	"locCaptcha": "en",
	"cvPDF_Msg": "Resume in PDF",
	"cvPDF_File": "/Resume - Maxime Princelle.pdf",
	"errorMsg": "Sorry but an error occurred while sending your message. Please try again.",
	"spamMsg": "Sorry but the verification service did not validate your message. Please try again.",
	"successMsg": "Your message has been sent successfully."
};
  
export default resumeData;
